import React from 'react';

// Section components for the Diligentsia x Certifii pages. Each receives `c` — its slice of
// CERTIFII_CONTENT for the active persona — so one set of markup serves company, advisor and
// investor. Sections taking no `c` are identical for all three.
// Assets are shared across personas, so they are required once here.
const DLG_LOGO = require('../../../../images/icon.png');
const CERTIFII = require('../../../../images/certifii-assets/certifii.png');
const WTS1 = require('../../../../images/certifii-assets/where-to-start-1.png');
const WTS2 = require('../../../../images/certifii-assets/where-to-start-2.png');
const SHOT1 = require('../../../../images/certifii-assets/CTI-dashboard-1.png');
const SHOT2 = require('../../../../images/certifii-assets/CTI-dashboard-2.png');
const SHOT3 = require('../../../../images/certifii-assets/CTI-dashboard-3.png');
// Every "Book a call" on these pages goes to the same booking link.
const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';

export const CertifiiHeader = () => (
        <header className="wrap cb-header">
            <div className="brands">
                <img className="dlg-mark" src={DLG_LOGO} alt="Diligentsia" />
                <span className="x">
                    ×
                </span>
                <img className="certifii-mark" src={CERTIFII} alt="Certifii" />
            </div>
            <a href={KOALENDAR} target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                Book a call
            </a>
        </header>
);

export const CertifiiHero = ({ c }) => (
        <section className="cb-hero">
            <div className="cb-hero-glow">
            </div>
            <div className="wrap cb-hero-grid">
                <div>
                    <div className="hero-eyebrow-row">
                        <span className="eyebrow">
                            Partnership with Certifii
                        </span>
                        <img className="hero-eyebrow-logo" src={CERTIFII} alt="Certifii" />
                    </div>
                    <h1>
                        {c.t1}
                    </h1>
                    <p className="lead">
                        {c.t2}
                    </p>
                    <p className="lead">
                        {c.t3}
                        <strong>
                            before
                        </strong>
                        {c.t4}
                    </p>
                    <div className="cb-hero-ctas">
                        <a href={KOALENDAR} target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{width: '150px'}}>
                            Book a call
                        </a>
                    </div>
                    <div className="cb-hero-footnote">
                        {c.t5}
                    </div>
                </div>
                <div className="cb-hero-visual">
                    <div className="cti-card">
                        <div className="cti-head">
                            <h4>
                                Certifii Trust Index (CTI)
                            </h4>
                            <span className="illus">
                                Illustrative
                            </span>
                        </div>
                        <div className="cti-ring-row">
                            <div className="cti-ring">
                                <svg viewBox="0 0 120 120">
                                    <circle cx="60" cy="60" r="52" fill="none" stroke="#E7E9EF" strokeWidth="12" />
                                    <circle cx="60" cy="60" r="52" fill="none" stroke="#0E2235" strokeWidth="12" strokeDasharray="326.7" strokeDashoffset="176.4" strokeLinecap="round" />
                                </svg>
                                <div className="cti-num">
                                    <span className="n">
                                        46
                                    </span>
                                    <span className="d">
                                        /100
                                    </span>
                                </div>
                            </div>
                            <div className="cti-ring-label">
                                Overall CTI score,
                                <br />
                                updated live as the model changes
                            </div>
                        </div>
                        <div className="cti-axes">
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Free Cash
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '72%', background: '#F87D38'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Liquidity
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '61%', background: '#F87D38'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Profitability
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '39%', background: '#F87D38'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Stress Resilience
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '75%', background: '#F87D38'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Forecast Evidence
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '15%', background: '#0E2235'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Forecast Discipline
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '82%', background: '#0E2235'}}>
                                    </span>
                                </div>
                            </div>
                            <div className="cti-axis-row">
                                <span className="axis-name">
                                    Forecast Coherence
                                </span>
                                <div className="axis-bar">
                                    <span style={{width: '100%', background: '#4E9F9A'}}>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiHeroInvestor = () => (
        <section className="cb-hero">
            <div className="cb-hero-glow">
            </div>
            <div className="wrap cb-hero-grid">
                <div>
                    <div className="hero-eyebrow-row">
                        <span className="eyebrow">
                            Partnership with Certifii
                        </span>
                        <img className="hero-eyebrow-logo" src={CERTIFII} alt="Certifii" />
                    </div>
                    <h1>
                        Stop reviewing every portfolio model by hand. See every company on one standard.
                    </h1>
                    <p className="lead">
                        Reviewing disparate financial models across a portfolio is time-consuming and doesn't scale — every founder builds differently, and every model needs re-learning before you can trust it. Certifii, now being built into Diligentsia, standardises, diligences and compares every portfolio company's model against the same seven-axis standard.
                    </p>
                    <p className="lead">
                        Give your portfolio the same tooling — an AI-built starter model, a sophisticated Series A build, or the standardised toolkit fractional CFOs use — and what lands in your Deal Room is <strong> already </strong> in a shape you can compare, and take straight to IC.
                    </p>
                    <div className="cb-hero-ctas">
                        <a href={KOALENDAR} target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{width: '150px'}}>
                            Book a call
                        </a>
                    </div>
                    <div className="cb-hero-footnote">
                        One licence, one portfolio · Free for every portfolio company to build and self-diligence prior to sharing · IC-ready comparables
                    </div>
                </div>
                <div className="cb-hero-visual">
                    <div className="pf-card">
                        <div className="pf-head">
                            <h4>
                                Portfolio Index — Financial
                            </h4>
                            <span className="illus">
                                Illustrative
                            </span>
                        </div>
                        <div className="pf-sub">
                            CTI scores across your portfolio, one screen
                        </div>
                        <div className="pf-tabs">
                            <span>
                                Portfolio
                            </span>
                            <span>
                                Your Firm
                            </span>
                            <span>
                                InvestorMatch
                            </span>
                            <span>
                                AnyList
                            </span>
                            <span className="active">
                                Financial
                            </span>
                            <span>
                                Technology
                            </span>
                        </div>
                        <div className="pf-row">
                            <div className="pf-co">
                                <span className="pf-dot" style={{background: '#1EAD5C'}}>
                                </span>
                                Solace Biotech Ltd
                            </div>
                            <div className="pf-bar">
                                <span style={{width: '78%', background: '#1EAD5C'}}>
                                </span>
                            </div>
                            <div className="pf-score good">
                                78
                            </div>
                        </div>
                        <div className="pf-row">
                            <div className="pf-co">
                                <span className="pf-dot" style={{background: '#F87D38'}}>
                                </span>
                                Northbridge Foods
                            </div>
                            <div className="pf-bar">
                                <span style={{width: '57%', background: '#F87D38'}}>
                                </span>
                            </div>
                            <div className="pf-score mid">
                                57
                            </div>
                        </div>
                        <div className="pf-row">
                            <div className="pf-co">
                                <span className="pf-dot" style={{background: '#FB7785'}}>
                                </span>
                                Vantage Robotics
                            </div>
                            <div className="pf-bar">
                                <span style={{width: '39%', background: '#FB7785'}}>
                                </span>
                            </div>
                            <div className="pf-score watch">
                                39
                            </div>
                        </div>
                        <div className="pf-row">
                            <div className="pf-co">
                                <span className="pf-dot" style={{background: '#1EAD5C'}}>
                                </span>
                                Halo Diagnostics
                            </div>
                            <div className="pf-bar">
                                <span style={{width: '82%', background: '#1EAD5C'}}>
                                </span>
                            </div>
                            <div className="pf-score good">
                                82
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiBenefits = ({ c }) => (
        <section className="benefits-section">
            <div className="wrap">
                <div className="section-head">
                    <h2>
                        {c.t1}
                    </h2>
                    <p>
                        {c.t2}
                    </p>
                </div>
                <div className="benefits-grid">
                    <div className="benefit-card">
                        <span className="b-tag">
                            {c.t3}
                        </span>
                        <div className="b-icon">
                            {c.t4}
                        </div>
                        <h3>
                            {c.t5}
                        </h3>
                        <p>
                            {c.t6}
                        </p>
                    </div>
                    <div className="benefit-card">
                        <span className="b-tag">
                            {c.t7}
                        </span>
                        <div className="b-icon">
                            {c.t8}
                        </div>
                        <h3>
                            {c.t9}
                        </h3>
                        <p>
                            {c.t10}
                        </p>
                    </div>
                    <div className="benefit-card">
                        <span className="b-tag">
                            {c.t11}
                        </span>
                        <div className="b-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 15.5a8 8 0 1 1 16 0" />
                                <path d="M12 15.5l4.2-5.2" />
                                <circle cx="12" cy="15.5" r="1.15" fill="currentColor" stroke="none" />
                            </svg>
                        </div>
                        <h3>
                            {c.t12}
                        </h3>
                        <p>
                            {c.t13}
                        </p>
                    </div>
                    <div className="benefit-card">
                        <span className="b-tag">
                            {c.t14}
                        </span>
                        <div className="b-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="7.5" cy="7.5" r="3" />
                                <circle cx="16.5" cy="16.5" r="3" />
                                <path d="M9.8 9.8l4.4 4.4" />
                            </svg>
                        </div>
                        <h3>
                            {c.t15}
                        </h3>
                        <p>
                            {c.t16}
                        </p>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiFlow = ({ c }) => (
        <section className="flow-section" id="how-it-works">
            <div className="wrap">
                <div className="section-head">
                    <span className="eyebrow">
                        How it works
                    </span>
                    <h2>
                        {c.t1}
                    </h2>
                    <p>
                        {c.t2}
                    </p>
                </div>
                <div className="flow-grid">
                    <div className="flow-card">
                        <div className="fc-step">
                            Step 1
                        </div>
                        <span className="fc-price free">
                            {c.t3}
                        </span>
                        <h4>
                            {c.t4}
                        </h4>
                        <p>
                            {c.t5}
                        </p>
                    </div>
                    <div className="flow-card">
                        <div className="fc-step">
                            Step 2
                        </div>
                        <span className="fc-price free">
                            {c.t6}
                        </span>
                        <h4>
                            {c.t7}
                        </h4>
                        <p>
                            {c.t8}
                        </p>
                    </div>
                    <div className="flow-card">
                        <div className="fc-step">
                            Step 3
                        </div>
                        <span className={c.t9}>
                            {c.t10}
                        </span>
                        <h4>
                            {c.t11}
                        </h4>
                        <p>
                            {c.t12}
                        </p>
                    </div>
                    <div className="flow-card">
                        <div className="fc-step">
                            Step 4
                        </div>
                        <span className={c.t13}>
                            {c.t14}
                        </span>
                        <h4>
                            {c.t15}
                        </h4>
                        <p>
                            {c.t16}
                        </p>
                    </div>
                </div>
                <p className="flow-footnote">
                    {c.t17}
                    <span>
                        {c.t18}
                    </span>
                </p>
            </div>
        </section>
);

export const CertifiiCti = ({ c }) => (
        <section className="cti-section">
            <div className="wrap">
                <div className="cti-copy">
                    <span className="eyebrow">
                        The Certifii Trust Index
                    </span>
                    <h2>
                        A single score, built from seven things that actually predict trouble
                    </h2>
                    <p>
                        {c.t1}
                    </p>
                    <ul>
                        <li>
                            {c.t2}
                        </li>
                        <li>
                            {c.t3}
                        </li>
                        <li>
                            Drill into any axis to see exactly what's driving the number
                        </li>
                    </ul>
                </div>
                <div className={c.t4}>
                    <div className="cti-head">
                        <h4>
                            Certifii Trust Index (CTI)
                        </h4>
                        <span className="illus">
                            Illustrative
                        </span>
                    </div>
                    <div className="cti-ring-row">
                        <div className="cti-ring">
                            <svg viewBox="0 0 120 120">
                                <circle cx="60" cy="60" r="52" fill="none" stroke="#E7E9EF" strokeWidth="12" />
                                <circle cx="60" cy="60" r="52" fill="none" stroke="#4A67FF" strokeWidth="12" strokeDasharray="326.7" strokeDashoffset="140.5" strokeLinecap="round" />
                            </svg>
                            <div className="cti-num">
                                <span className="n">
                                    57
                                </span>
                                <span className="d">
                                    /100
                                </span>
                            </div>
                        </div>
                        <div className="cti-ring-label">
                            Overall CTI score,
                            <br />
                            updated live as the model changes
                        </div>
                    </div>
                    <div className="cti-axes">
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Free Cash
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '72%', background: '#4A67FF'}}>
                                </span>
                            </div>
                            <span className="axis-val">
                                72
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Liquidity
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '61%', background: '#4A67FF'}}>
                                </span>
                            </div>
                            <span className="axis-val">
                                61
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Profitability
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '39%', background: '#FB7785'}}>
                                </span>
                            </div>
                            <span className="axis-val warn">
                                39
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Stress Resilience
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '75%', background: '#4A67FF'}}>
                                </span>
                            </div>
                            <span className="axis-val">
                                75
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Forecast Evidence
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '15%', background: '#FB7785'}}>
                                </span>
                            </div>
                            <span className="axis-val warn">
                                15
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Forecast Discipline
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '82%', background: '#1EAD5C'}}>
                                </span>
                            </div>
                            <span className="axis-val">
                                82
                            </span>
                        </div>
                        <div className="cti-axis-row">
                            <span className="axis-name">
                                Forecast Coherence
                            </span>
                            <div className="axis-bar">
                                <span style={{width: '100%', background: '#1EAD5C'}}>
                                </span>
                            </div>
                            <span className="axis-val">
                                100
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiTiers = () => (
        <section className="tiers-section">
            <img className="tiers-bg-1" src={WTS1} alt="" />
            <img className="tiers-bg-2" src={WTS2} alt="" />
            <div className="wrap">
                <div className="section-head">
                    <h2>
                        Choose where to start
                    </h2>
                    <p>
                        Choose the route that fits the business and the raise today. The CTI can be upgraded later as more evidence and financial detail become available.
                    </p>
                </div>
                <div className="tiers-grid">
                    <div className="tier-card">
                        <div className="tier-tag">
                            Baseline Forecast
                        </div>
                        <h3>
                            Make the case for your first raise
                        </h3>
                        <p className="tier-audience">
                            For pre-seed and seed businesses.
                        </p>
                        <p>
                            Set out what is being raised, what it unlocks and the milestones it needs to fund. Give potential backers a clear picture of the next stage of the business, even before there is a long trading history.
                        </p>
                        <p className="tier-note">
                            Start the funding conversation with a plan that makes sense.
                        </p>
                    </div>
                    <div className="tier-card highlight">
                        <div className="tier-tag">
                            Certifii Lite
                        </div>
                        <h3>
                            Turn trading progress into a case for more capital
                        </h3>
                        <p className="tier-audience">
                            For founders with trading history and a larger raise ahead.
                        </p>
                        <p>
                            Bring together revenue, costs, cash and plans so a capital provider can understand what the business has achieved, what comes next and why the funding is needed.
                        </p>
                        <p className="tier-note">
                            Help the right capital provider see the business being built, not just the fragments they happen to receive.
                        </p>
                    </div>
                    <div className="tier-card">
                        <div className="tier-tag">
                            Certifii Pro
                        </div>
                        <h3>
                            Give the people around the raise a model they can stand behind
                        </h3>
                        <p className="tier-audience">
                            For CFOs, accountants and advisers.
                        </p>
                        <p>
                            Build the detailed financial model behind the case, including the funding, tax and accounting treatment properly to explain the plan and answer the questions that follow.
                        </p>
                        <p className="tier-note">
                            Give the finance team one case they can explain, challenge and maintain.
                        </p>
                    </div>
                </div>
                <p className="tiers-footnote">
                    One plan. A clearer case for capital. Every route connects the plan to its cash consequences and highlights the questions that still need answering. As evidence and detail are added, it becomes easier for the people evaluating the business to act.
                </p>
            </div>
        </section>
);

export const CertifiiScreens = ({ c }) => (
        <section className="screens-section">
            <div className="wrap">
                <div className="section-head">
                    <h2>
                        {c.t1}
                    </h2>
                    <p>
                        {c.t2}
                    </p>
                </div>
                <div className="screens-lead">
                    <img src={SHOT1} alt="Full Certifii Trust Index dashboard with drivers panel" />
                    <div className="screens-caption">
                        {c.t3}
                    </div>
                </div>
                <div className="screens-pair">
                    <div className="screens-card">
                        <img src={SHOT2} alt="Drill-down analysis on a single CTI axis" />
                        <div className="screens-caption">
                            {c.t4}
                        </div>
                    </div>
                    <div className="screens-card">
                        <img src={SHOT3} alt="Positive and watch drivers behind the CTI score" />
                        <div className="screens-caption">
                            {c.t5}
                        </div>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiPricing = ({ c }) => (
        <section className="pricing-section">
            <div className="wrap">
                <div className="section-head">
                    <h2>
                        What does it cost?
                    </h2>
                    <p>
                        {c.t1}
                    </p>
                </div>
                <div className="pricing-grid">
                    <div className="price-card">
                        <div className="p-tag">
                            Build
                        </div>
                        <h3>
                            Free
                        </h3>
                        <div className="p-amount">
                            £0
                        </div>
                        <p className="p-desc">
                            {c.t2}
                        </p>
                    </div>
                    <div className="price-card highlight">
                        <div className="p-tag">
                            Get your CTI score
                        </div>
                        <h3>
                            Free
                        </h3>
                        <div className="p-amount">
                            £0
                        </div>
                        <p className="p-desc">
                            {c.t3}
                        </p>
                    </div>
                    <div className="price-card">
                        <div className="p-tag">
                            Share with a funder
                        </div>
                        <h3>
                            £59+VAT/mo
                        </h3>
                        <div className="p-amount">
                            £59
                            <span style={{fontSize: '14px', color: 'var(--body-text)', fontWeight: '500'}}>
                                +VAT/mo
                            </span>
                        </div>
                        <p className="p-desc">
                            {c.t4}
                        </p>
                    </div>
                </div>
                <div className="promo-box">
                    <div className="promo-left">
                        <span className="promo-label">
                            Promo code
                        </span>
                        <span className="pb-text">
                            {c.t5}
                            <strong>
                                20% off
                            </strong>
                            all Certifii plans.
                        </span>
                    </div>
                    <div className="promo-code-chip">
                        <span className="pcc-text">
                            DG-20
                        </span>
                        <span className="pcc-hint">
                            Enter at checkout
                        </span>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiPricingInvestor = () => (
        <section className="pricing-section">
            <div className="wrap">
                <div className="section-head">
                    <h2>
                        What does it cost?
                    </h2>
                    <p>
                        One annual licence for your firm. Nothing extra for your portfolio companies to build and self-diligence prior to sharing.
                    </p>
                </div>
                <div className="pricing-single">
                    <div className="p-tag">
                        Diligentsia × Certifii for Investors
                    </div>
                    <h3>
                        Annual licence
                    </h3>
                    <div className="p-amount">
                        £7,500
                        <span>
                            +VAT / year
                        </span>
                    </div>
                    <p className="p-desc">
                        2 seats and 50 CTI assessments a year, plus public index access — for one price, for your whole firm.
                    </p>
                </div>
                <div className="pricing-included">
                    <div className="pi-item">
                        <div className="pi-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 20V14" />
                                <path d="M10 20V9" />
                                <path d="M16 20V12.5" />
                                <path d="M20.5 20V5" />
                            </svg>
                        </div>
                        <span className="pi-label">
                            50 CTI assessments a year
                        </span>
                    </div>
                    <div className="pi-item">
                        <div className="pi-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M7 3.5h8.5L19 7v13.5a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V4.5a1 1 0 0 1 1-1Z" />
                                <path d="M9.3 12.3l1.4 1.4L14 10.4" />
                                <path d="M9.3 17l1.4 1.4L14 15.1" />
                            </svg>
                        </div>
                        <span className="pi-label">
                            Free build &amp; self-diligence prior to sharing
                        </span>
                    </div>
                    <div className="pi-item">
                        <div className="pi-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="7.5" cy="7.5" r="3" />
                                <circle cx="16.5" cy="16.5" r="3" />
                                <path d="M9.8 9.8l4.4 4.4" />
                            </svg>
                        </div>
                        <span className="pi-label">
                            Side-by-side portfolio comparison
                        </span>
                    </div>
                    <div className="pi-item">
                        <div className="pi-icon">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M4 15.5a8 8 0 1 1 16 0" />
                                <path d="M12 15.5l4.2-5.2" />
                                <circle cx="12" cy="15.5" r="1.15" fill="currentColor" stroke="none" />
                            </svg>
                        </div>
                        <span className="pi-label">
                            IC-ready CTI reporting
                        </span>
                    </div>
                </div>
            </div>
        </section>
);

export const CertifiiFinal = ({ c }) => (
        <section className="final-section" id="book-a-call">
            <div className="wrap">
                <div className="final-cta">
                    <h2>
                        {c.t1}
                    </h2>
                    <p>
                        {c.t2}
                    </p>
                    <div className="final-cta-ctas">
                        <a href={KOALENDAR} target="_blank" rel="noopener noreferrer" className="btn btn-white" style={{gap: '10px'}}>
                            <img className="w30px dlg-inline-mark" src={DLG_LOGO} alt="Diligentsia" />
                            Book a call
                        </a>
                        <a href="#" className="btn btn-orange">
                            View sample report
                        </a>
                    </div>
                    <div className="final-footnote">
                        {c.t3}
                    </div>
                </div>
            </div>
        </section>
);
